<template>
  <div>
    <DxDataGrid
      :columns="itemHeaders"
      :summary="summary"
      :data-source="lineItems"
      :show-borders="true"
      :allow-column-resizing="true"
      :showRowLines="true"
      key-expr="id"
      @toolbar-preparing="onToolbarPreparing"
      :ref="itemDataGridRefKey"
      :repaint-changes-only="true"
      @row-updating="updateRow"
    >
      <template #rlt-field-show="{ data: cellData }">
        <div>
          <relate-show
            :cellData="cellData"
            :prefix="slug"
            :fieldDef="itemHeaders[cellData.columnIndex]"
          />
        </div>
      </template>
    </DxDataGrid>
  </div>
</template>
<script>
import {
  DxDataGrid,
  DxColumn,
  DxEditing,
  DxPopup,
  DxLookup,
  DxForm,
  DxHeaderFilter,
  DxFilterRow,
  DxGrouping,
  DxGroupPanel,
  DxScrolling,
  DxPager,
  DxPaging,
} from "devextreme-vue/data-grid";
import CustomFieldTypesList from "./CustomFieldTypesforList.vue";
import RelateShow from "./line_item/ListRelateFieldShow.vue";
import DxButton from "devextreme-vue/button";
import DxDateBox from "devextreme-vue/date-box";
import CustomStore from "devextreme/data/custom_store";

const itemDataGridRefKey = "itemDataGrid";
const ledgerDataGridRefKey = "ledgerDataGrid";

let sTotal = 0;

export default {
  props: {
    modelValue: {
      type: Object,
      default: () => ({}),
      required: true,
    },
    def: {
      type: Object,
      default: () => ({}),
      required: true,
    },
    defaultData: {
      type: Array,
      default: [],
    },
    fname: String,
    slug: String,
    modRoute: String,
    isBatchDetail: Boolean,
  },
  components: {
    DxDataGrid,
    DxEditing,
    DxColumn,
    DxButton,
    DxDateBox,
    CustomFieldTypesList,
    RelateShow,
  },
  data: function () {
    return {
      itemDataGridRefKey,
      ledgerDataGridRefKey,
      sTotal,
      newRowPosition: "last",
      lineItems: { items: [] },
      tempDataSource: [],
      items: [],
      itemHeaders: [],
      summary: {
        recalculateWhileEditing: true,
        totalItems: [
          {
            column: "Amount",
            summaryType: "sum",
            displayFormat: "Total: {0}",
          },
        ],
      },
      toolbar: {
        visible: false,
      },
    };
  },
  methods: {
    addNewRow() {
      this.itemDataGrid.addRow();
    },
    save() {
      this.itemDataGrid.saveEditData();
    },
    onToolbarPreparing: function (e) {
      var toolbarItems = e.toolbarOptions.items;
      $.each(toolbarItems, function (_, item) {
        if (item.name == "saveButton" || item.name == "revertButton") {
          item.visible = false;
        }
      });
    },
    sortItems() {
      this.lineItems = this.sortedItems;
    }
  },
  created: function () {},
  mounted() {
    this.itemHeaders = this.def.editorOptions.line_items;

    if (this.isBatchDetail) {
      this.lineItems = this.modelValue;
    } else {
      this.lineItems = this.modelValue.original.results.data;
    }

    this.sortItems();
    console.log("LINE ITEM DETAIL RESULT",this.lineItems);
  },
  computed: {
    itemDataGrid: function () {
      return this.$refs[itemDataGridRefKey].instance;
    },
    sortedItems() {
      return this.lineItems.slice().sort((a, b) => new Date(a.created_at) - new Date(b.created_at));
    }
  },
};
</script>